
const getEnv = (envConst) => {
  return process.env[`${envConst}`] || ''
}

const getBoolean = (envConst) => {
  const env = getEnv(envConst)
  return env === 'true'
}

export const REACT_APP_IS_ACTUAL_REVENUE_ALLOCATION_EDITABLE = getBoolean('REACT_APP_IS_ACTUAL_REVENUE_ALLOCATION_EDITABLE')



// WEBPACK FOOTER //
// ./src/lib/utils/envConstants.js